import type {
  BackgroundValue,
  CollectionItem,
  FontValue,
  LanguageValue,
  LinkValue
} from '@elfsight/configurator-contracts';
import type { WidgetSettings } from '@wu/widget-core';

export type PollSettings = WidgetSettings<{
  // poll
  question: string;
  answers: AnswerItem[];

  // theme
  background: BackgroundValue;
  textColor: string;
  accentColor: string;
  font: FontValue;

  // settings
  showSuccessMessage: boolean;
  successMessageText: string;
  showActionButton: boolean;
  actionButtonText: string;
  actionButtonLink: LinkValue;
  resultView: ResultView;
  language: LanguageValue | undefined;
  customCSS: string;
  customJS: string;
}>;

export enum ViewType {
  VoteView = 'vote-view',
  ResultView = 'result-view'
}

export type AnswerItem = CollectionItem<{ answer: string }>;

export type ResultView = 'votes' | 'percentages' | 'votesAndPercentages';

export type Vote = {
  id: AnswerItem['id'];
  count: number;
  percentage: number;
};

export type VotesData = {
  total: number;
  votes: Vote[];
};

export type StorageVotes = {
  id: Vote['id'];
  pid: string;
};
